import { combineReducers } from 'redux';
import auth from './auth/auth';

export default combineReducers({
  auth: auth
});
